import { type ModalProps as BaseUiModalProps, Spin } from '@faceup/ui-base'
import { Suspense } from 'react'
import { createPortal } from 'react-dom'
import { ModalErrorBoundary } from './ModalErrorBoundary'

type ModalProps = Pick<BaseUiModalProps, 'open'>

type WithModalSuspenseProps<T extends ModalProps> = T & ModalProps

export const withModalSuspense = <T extends ModalProps>(Component: React.ComponentType<T>) => {
  return (props: WithModalSuspenseProps<T>) => {
    if (!props.open) {
      return null
    }
    return (
      <ModalErrorBoundary>
        <Suspense fallback={createPortal(<Spin size='large' fullscreen />, document.body)}>
          <Component {...props} />
        </Suspense>
      </ModalErrorBoundary>
    )
  }
}
